import fetch from "@/fetch";
// 预约取书通知内容详情页面数据获取接口
export const bookNotice = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/wxmsgdetail/holdrequest",
    data: params,
    loading: true,
    actionTypeCode: '29',
    actionTypeDesc: '预约取书通知',
  });
};
// 图书到期提醒（5天）详情页面数据获取接口
export const loanNoticeFive = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/wxmsgdetail/loannotice5",
    data: params,
    loading: true,
    actionTypeCode: '30',
    actionTypeDesc: '图书到期提醒（5天）通知',
  });
};
// 图书到期提醒（3天）详情页面数据获取接口
export const loanNoticeThree = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/wxmsgdetail/loannotice3",
    data: params,
    loading: true,
    actionTypeCode: '31',
    actionTypeDesc: '图书到期提醒（3天）通知',
  });
};
// 图书逾期催还详情页面数据获取接口
export const overDueNotice = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/wxmsgdetail/overdue",
    data: params,
    loading: true,
    actionTypeCode: '32',
    actionTypeDesc: '图书逾期催还通知',
  });
};
// 图书预约取消详情页面数据获取接口
export const holdDeleteNotice = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/wxmsgdetail/holddelete",
    data: params,
    loading: true,
    actionTypeCode: '33',
    actionTypeDesc: '图书预约取消通知',
  });
};
// 外借图书预约催还详情页面数据获取接口
export const urgeReturnNotice = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/wxmsgdetail/urgereturn",
    data: params,
    loading: true,
    actionTypeCode: '34',
    actionTypeDesc: '外借图书预约催还通知',
  });
};
// 外借图书取消催还详情页面数据获取接口
export const urgeReturnCancelNotice = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/wxmsgdetail/urgereturncancel",
    data: params,
    loading: true,
    actionTypeCode: '35',
    actionTypeDesc: '外借图书取消催还通知',
  });
};